import { FormikProps } from "formik";
import { Checkout } from "src/organisms/CheckoutView/CheckoutStepInfo";
import { Profile } from "src/molecules/ProfileForm/ProfileForm";
import { Address } from "./AddressForm";

export const clearAddressFields = (
  formik: FormikProps<Checkout> | FormikProps<Profile>,
  addressType: "shippingAddress" | "billingAddress"
): void => {
  const addressFields: Omit<
    Address & { isStreetNumberNotRequired: boolean },
    "country"
  > = {
    streetName: "",
    streetNumber: "",
    additionalStreetInfo: "",
    postalCode: "",
    city: "",
    state: "",
    isStreetNumberNotRequired: false,
  };

  Object.entries(addressFields).forEach(([key, value]) => {
    void formik.setFieldTouched(`${addressType}.${key}`, false);
    void formik.setFieldValue(`${addressType}.${key}`, value);
  });
};
